export default __webpack_public_path__ + "static/media/hopp-hopp-hopp.61665cf2.webp";